import parse from 'html-react-parser';
import { useReducer } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../../../hook/useFetch";
import ToggleButton from '../../ToggleButton';


export default function NewUser() {
    let componentReducer = (state, action) => {

        switch (action.type) {
            case 'email':
                return { ...state, email: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'confirmation_password':
                return { ...state, confirmation_password: action.data }
            case 'username':
                return { ...state, username: action.data }
            case 'is_admin':
                return { ...state, is_admin: action.data }

        }

    }

    const [componentState, componentDispatch] = useReducer(componentReducer, {
        email: null,
        password: null,
        confirmation_password: null,
        username: null,
        is_admin: null
    })



    const { error, post } = useFetch()

    let navigate = useNavigate()

    return <div className="edit-container grid-container-2-col" >
        <form className="edit-form bg-white left-col" onSubmit={(e) => {
            e.preventDefault()

            post('/admin/user', {
                email: componentState.email,
                password: componentState.password,
                confirmation_password: componentState.confirmation_password,
                username: componentState.username,
                is_admin: componentState.is_admin

            }, null, (data) => {

                navigate('/admin/users')
            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{parse(error)}</p>
                </div>
            }

            <div className="form-group">
                <label >Username</label>
                <input type="text" className="form-control" placeholder="Username" defaultValue={componentState.username} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'username',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label >Email address</label>
                <input type="email" className="form-control" placeholder="Email" defaultValue={componentState.email} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label >Password</label>
                <input type="password" className="form-control" placeholder="Password" defaultValue={componentState.password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'password',
                            data: e.target.value
                        }
                    )
                }} required />
            </div>

            <div className="form-group">
                <label >Password Confirmation</label>
                <input type="password" className="form-control" placeholder="Password Confirmation" defaultValue={componentState.confirmation_password} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'confirmation_password',
                            data: e.target.value
                        }
                    )
                }} required />
            </div>

            <div className="form-group">
               
                <ToggleButton
                    onToggle={() => {
                        componentDispatch(
                            {
                                type: 'is_admin',
                                data: !componentState.is_admin
                            }
                        )
                    }}
                    id='isadmin'
                    label='IsAdmin'
                    defaultChecked={componentState.is_admin}

                />


            </div>


            <button type="submit" className="btn btn-primary" >Register</button>

        </form>
    </div>
}
